import React, { FC } from 'react';
import { Alert, AlertProps } from '@mui/material';

const MfAlert: FC<AlertProps> = ({
  children,
  severity = 'warning',
  ...rest
}) => (
  <Alert severity={severity} {...rest}>
    {children}
  </Alert>
);

export default MfAlert;
